import $ from "jquery";


const render = () => {
    var $meum = $(".meum-img"),
        $navBg =$(".nav-bg"),
        $mask = $(".mask"),
        $close = $(".close-img");
    $meum.on('click', function () {
        $(this).hide();
        $navBg.addClass('show');
        $mask.addClass('show');
    });
    $close.on('click',function () {
        $navBg.removeClass('show');
        $mask.removeClass('show');
        $meum.show();
    })
};
render();
